import React from "react";
import Layout from "./Layout";
import { Link } from "react-router-dom";

const Rewards = () => {
  return (
    <Layout>
      <div className="profileLayout-padding margin-desktop">
        <div className="row mobile-full-height no-gutters">
          <div className="col col-12">
            <div>
              <div className="justify-space-around hidden-md-and-up v-card v-sheet theme--light elevation-0">
                <div
                  className="row d-flex justify-space-between no-gutters"
                  style={{ "background-color": "rgb(243, 245, 246)" }}
                >
                  <div className="pa-0 d-flex justify-center align-center col col-4">
                    <span className="rewardText">Rewards</span>
                  </div>
                  <div className="pa-0 d-flex justify-end col col-3">
                    <div
                      className="v-image v-responsive theme--light"
                      style={{ height: "100px" }}
                    >
                      <div
                        className="v-responsive__sizer"
                        style={{ "padding-bottom": "92.3077%" }}
                      />
                      <div
                        className="v-image__image v-image__image--cover"
                        style={{
                          "background-image":
                            'url("/assets/new/rewardIcon.png")',
                          "background-position": "center center",
                        }}
                      />
                      <div
                        className="v-responsive__content"
                        style={{ width: "65px" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row pt-3 no-gutters">
                  {/**/}
                  <div className="text-left col col-12">
                    <div className="scrollable-container pa-3 ma-3">
                      <Link
                        to="/reward"
                        className="reward-tab mr-2 inactive-btn v-btn--active v-btn v-btn--plain v-btn--router theme--light v-size--default active-btn"
                      >
                        <span className="v-btn__content">
                          <div
                            className="v-image v-responsive theme--light"
                            style={{ height: "20px", width: "20px" }}
                          >
                            <div
                              className="v-responsive__sizer"
                              style={{ "padding-bottom": "100%" }}
                            />
                            <div
                              className="v-image__image v-image__image--cover"
                              style={{
                                "background-image":
                                  'url("/assets/new/rewardStoreIcon-active.svg")',
                                "background-position": "center center",
                              }}
                            />
                            <div
                              className="v-responsive__content"
                              style={{ width: "11px" }}
                            />
                          </div>
                          <span className="pl-2">Reward Store</span>
                        </span>
                      </Link>
                      <button
                        type="button"
                        className="reward-tab mr-2 inactive-btn v-btn v-btn--plain theme--light v-size--default"
                      >
                        <span className="v-btn__content">
                          <div
                            className="v-image v-responsive theme--light"
                            style={{ height: "20px", width: "20px" }}
                          >
                            <div
                              className="v-responsive__sizer"
                              style={{ "padding-bottom": "100%" }}
                            />
                            <div
                              className="v-image__image v-image__image--cover"
                              style={{
                                "background-image":
                                  'url("/assets/new/dailyCheckInIcon.svg")',
                                "background-position": "center center",
                              }}
                            />
                            <div
                              className="v-responsive__content"
                              style={{ width: "12px" }}
                            />
                          </div>
                          <span className="pl-2">Check-In</span>
                        </span>
                      </button>
                      <a
                        href="/mluckywheel"
                        className="reward-tab mr-2 inactive-btn v-btn v-btn--plain v-btn--router theme--light v-size--default inactive-btn"
                      >
                        <span className="v-btn__content">
                          <div
                            className="v-image v-responsive theme--light"
                            style={{ height: "20px", width: "20px" }}
                          >
                            <div
                              className="v-responsive__sizer"
                              style={{ "padding-bottom": "116.667%" }}
                            />
                            <div
                              className="v-image__image v-image__image--cover"
                              style={{
                                "background-image":
                                  'url("/assets/new/wofIcon.svg")',
                                "background-position": "center center",
                              }}
                            />
                            <div
                              className="v-responsive__content"
                              style={{ width: "12px" }}
                            />
                          </div>
                          <span className="pl-2">Wheel Of Fortune</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="v-card__text referralContainer">
                  <div className="referral-tier">
                    <div
                      className="v-snack pa-0 v-snack--centered v-snack--has-background v-snack--top"
                      style={{
                        "padding-bottom": "0px",
                        "padding-top": "0px",
                        "z-index": "1002 !important",
                        top: "25%",
                      }}
                    >
                      <div
                        className="v-snack__wrapper v-sheet theme--light"
                        style={{ width: "fit-content", display: "none" }}
                      >
                        <div
                          role="status"
                          aria-live="polite"
                          className="v-snack__content"
                        >
                          <div
                            role="alert"
                            className="v-alert mb-0 pa-1 v-sheet theme--light profile-alert-failed"
                            style={{ display: "none" }}
                          >
                            <div className="v-alert__wrapper">
                              <i
                                aria-hidden="true"
                                className="v-icon notranslate v-alert__icon mdi mdi-close-circle-outline theme--light"
                              />
                              <div className="v-alert__content"></div>
                              <button
                                type="button"
                                className="v-alert__dismissible v-btn v-btn--icon v-btn--round theme--light v-size--small"
                                aria-label="Close"
                              >
                                <span className="v-btn__content">
                                  <i
                                    aria-hidden="true"
                                    className="v-icon notranslate mdi mdi-close theme--light"
                                  />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="v-snack__action " />
                      </div>
                    </div>
                    <div className="row hidden-md-and-up justify-center">
                      <div style={{ "max-width": "100%" }}>
                        <div className="detailContainer_mobile">
                          <div className="container Product-Container">
                            <div
                              className="row"
                              style={{
                                "max-width": "100%",
                                "background-color": "rgb(239, 240, 245)",
                                margin: "0px",
                              }}
                            >
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-responsive__sizer"
                                      style={{ "padding-bottom": "100%" }}
                                    />
                                    <div
                                      className="v-image__image v-image__image--contain"
                                      style={{
                                        "background-image":
                                          'url("/assets/new/68eb99529c540.webp")',
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div
                                      className="v-responsive__content"
                                      style={{ width: "1080px" }}
                                    >
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-responsive__sizer"
                                          style={{ "padding-bottom": "100%" }}
                                        />
                                        <div
                                          className="v-image__image v-image__image--cover"
                                          style={{
                                            "background-image":
                                              'url("/assets/new/game-icon-hot.svg")',
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div
                                          className="v-responsive__content"
                                          style={{ width: "35px" }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      6000
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      Mobile Recharge ৳3000
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/**/}
      </div>
    </Layout>
  );
};

export default Rewards;
